import React from 'react'
import styled from 'styled-components'
import { motion, Variants } from 'framer-motion'
import { breakpointUpTo } from 'utils/breakpoints'

const StyledHeading = styled.h1`
  ${({ theme }) => theme.typography.XLH1}

  ${({ theme }) => breakpointUpTo(theme.breakpoints.xl)} {
    ${({ theme }) => theme.typography.LrgH1}
  }
  ${({ theme }) => breakpointUpTo(theme.breakpoints.lg)} {
    ${({ theme }) => theme.typography.MedH1}
  }
  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    ${({ theme }) => theme.typography.SmH1}
  }

  .line-container {
    overflow: hidden;
    display: inline-block;
    height: 7rem;
    margin: -0.5rem 0;

    ${({ theme }) => breakpointUpTo(theme.breakpoints.xl)} {
      height: 5.5rem;
    }

    ${({ theme }) => breakpointUpTo(theme.breakpoints.lg)} {
      height: 4.25rem;
    }

    ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
      height: 3.25rem;
    }
  }

  .line-content {
    display: block;
  }
`

const variants: Variants = {
  hidden: {
    y: '100%',
  },
  visible: {
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
}

type SpanProps = { text: string }

const AnimatedSpan = ({ text }: SpanProps) => {
  return (
    <span className="line-container">
      <motion.span
        variants={variants}
        initial="hidden"
        animate="visible"
        className="line-content"
      >
        {text}
      </motion.span>
    </span>
  )
}

type HeadingProps = { title: string }

export const Heading = ({ title }: HeadingProps) => {
  const splitText = title.split(' ')

  return (
    <StyledHeading>
      {splitText.map((word, idx) => (
        <React.Fragment key={idx}>
          <AnimatedSpan text={word} />{' '}
        </React.Fragment>
      ))}
    </StyledHeading>
  )
}
